import { render, staticRenderFns } from "./RepoEdit.vue?vue&type=template&id=00175022&scoped=true&"
import script from "./RepoEdit.vue?vue&type=script&lang=js&"
export * from "./RepoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RepoEdit.vue?vue&type=style&index=0&id=00175022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00175022",
  null
  
)

export default component.exports